var _circle, _path, _path2, _path3, _path4, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddStopActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 61,
    viewBox: "0 0 246 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.2812,
    cy: 30.75,
    r: 30,
    fill: "#9C4900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 15.75H16.9479C16.0274 15.75 15.2812 16.4962 15.2812 17.4167V24.0833C15.2812 25.0038 16.0274 25.75 16.9479 25.75H20.2812C21.2017 25.75 21.9479 25.0038 21.9479 24.0833V17.4167C21.9479 16.4962 21.2017 15.75 20.2812 15.75Z",
    stroke: "#F6EFE9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2786 42.4167C42.1196 42.4167 43.612 40.9243 43.612 39.0833C43.612 37.2424 42.1196 35.75 40.2786 35.75C38.4377 35.75 36.9453 37.2424 36.9453 39.0833C36.9453 40.9243 38.4377 42.4167 40.2786 42.4167Z",
    stroke: "#F6EFE9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9505 19.0859H38.6172C43.2189 19.0859 46.9505 24.3093 46.9505 30.7526V39.0859H43.6172M36.9505 39.0859H23.6172",
    stroke: "#F6EFE9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9505 19.0859L39.4505 30.7526H46.9505M26.1172 27.4193H38.6172M30.2839 19.0859V27.4193M18.6172 25.7526V44.0859",
    stroke: "#F6EFE9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 61.5703,
    y1: 30.25,
    x2: 243.57,
    y2: 30.25,
    stroke: "#9C4900",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddStopActive);
export default __webpack_public_path__ + "static/media/add_stop_active.4a58793764e5156e74e7716401e65933.svg";
export { ForwardRef as ReactComponent };